<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{fontSize:$pScreen.titleS}"
    >
      <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
    </div>

    <div style="width:100%"> 
      <div @click="birthDateClick" style="width: 100%; position: relative;">
        <Input
          v-model="attrObj.answerContent"
          :placeholder="placeholderDesc"
          :disabled="attrObj.disabled"
          readonly
        />
        <img class="dateIcon" src="../../../../../static/runtime/images/magic/date.svg" alt="" />
      </div>
      <div v-if="attrObj.isCheckError" class="errorTip">请选择时间</div>
    </div>
    
    <van-action-sheet v-model="birthDateShow">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :formatter="formatter"
        @cancel='birthDateCancel'
        @confirm='birthDateConfirm'
        :disabled="attrObj.disabled"
      />
    </van-action-sheet>  
  </div>
</template>




<script>
import { Cell, DatetimePicker, ActionSheet, Field, Row, Col } from 'vant';
import { FormType } from '../../../../commons/commonVariables.js';
export default {
  components: {
    [Row.name]:  Row, 
    [Col.name]: Col ,
    [Cell.name]: Cell,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet,
    [Field.name]: Field
  },  
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      minDate: new Date(),
      currentDate: new Date(),
      birthDateShow: false,
      placeholderDesc: !this.attrObj.desc ? '请选择' : this.attrObj.desc,
    };
  },
  created() {
    
  },
  //初始化后调用
  mounted: function() {
    
  },
  methods: {
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    },
    //日期格式化
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      } else if( type === 'day'){
        return `${value}日`
      }
      return value;
    },
    //取消按钮
    birthDateCancel(){
      this.birthDateShow = false;
    },
    //确定按钮
    birthDateConfirm(value){
      this.currentDate = value;
      this.attrObj.answerContent = this.$utils.date.getTimeFomat(value, 'yyyy-mm-dd');
      this.birthDateShow = false;
    },
    birthDateClick(){
      if(this.attrObj.disabled){
        return false;
      }
      this.birthDateShow = true;
    },
  }
};
</script>
<style>
    .customField {
      line-height: 1.5;
      padding: 4px 8px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      background: #fff;
      font-size: 14px;
      color: #515a6e;
    }
    .customField01{
      line-height: 1.5;
      padding: 4px 8px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      background: #f3f3f3;
      font-size: 14px;
      color: #ccc;
    }
    .ivu-input{
      color: #515a6e;
      font-size: 14px;
    }
    .ivu-input[disabled]{
      background: #f3f3f3;
      opacity: 1;
      cursor: not-allowed;
      color: #ccc;
      font-size: 14px;
    }
    .dateIcon {
      position: absolute;
      right: 8px;
      top: 7px;
      width: 20px;
      height: 20px;
    }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/time.vue